<template>
  <div class="container py-2 px-0 px-sm-2">
    <div class="row">
      <div class="col">
        <div class="accordion accordion-modern vehicle-register" id="vehicle-register-accordion">
          <v-collapse-group>
            <!-- Vehicle Type -->
            <div class="card card-default">
                <v-collapse-wrapper :active="true">
                  <div class="card-header" v-collapse-toggle>
                    <h4 class="card-title m-0">
                          <a class="accordion-toggle">
                        <i class="fas fa-car"></i>
                        {{ trans('Vehicle Type') }}
                      </a>
                    </h4>
                  </div>
                  <div v-collapse-content>
                    <vehicle-filter
                      :production-year.sync="formData.production_year"
                      :prod-from="fields.prod_from"
                      :prod-to="fields.prod_to"
                      :color.sync="formData.color"
                      :vin.sync="formData.vin"
                      :reg_date.sync="formData.reg_date"
                      :reg_plate.sync="formData.reg_plate"
                      :fuel.sync="formData.fuel"
                      :power.sync="formData.power"
                      :capacity.sync="formData.capacity"
                      :transmission.sync="formData.transmission"
                      :speedometer_mph.sync="formData.speedometer_mph"
                      :odometer.sync="formData.odometer"
                      :errors="errors"
                    />
                  </div>
                </v-collapse-wrapper>
            </div>

            <!-- Vehicle Photos -->
            <div class="card card-default">
                <v-collapse-wrapper>
                  <div class="card-header" v-collapse-toggle>
                    <h4 class="card-title m-0">
                          <a class="accordion-toggle">
                        <i class="far fa-images"></i>
                        {{ trans('Vehicle Photos') }}
                      </a>
                    </h4>
                  </div>
                  <div id="collapsePhotos" v-collapse-content>
                    <vehicle-photos
                      :api-route="photoUploadRoute"
                      :report-id="Number(this.fields.id)"
                      :photos.sync="formData.photos"
                      :errors="errors"
                    />
                  </div>
                </v-collapse-wrapper>
            </div>

            <!-- Vehicle Techs -->
            <div class="card card-default">
                <v-collapse-wrapper>
                  <div class="card-header" v-collapse-toggle>
                    <h4 class="card-title m-0">
                          <a class="accordion-toggle">
                        <i class="fas fa-cogs"></i>
                        {{ trans('Technical Details / Equipment') }}
                      </a>
                    </h4>
                  </div>
                  <div id="collapseTechs" v-collapse-content>
                    <vehicle-techs
                      :engine-number.sync="formData.engine_number"
                      :gearbox-number.sync="formData.gearbox_number"
                      :engine.sync="formData.engine"
                      :extras.sync="formData.extras"
                      :seat-material.sync="formData.seat_material"
                      :interior-color.sync="formData.interior_color"
                      :rims.sync="formData.rims"
                      :rims-manufacturer.sync="formData.rims_manufacturer"
                      :tyres.sync="formData.tyres"
                      :special-signs.sync="formData.special_signs"
                      :errors="errors"
                    />
                  </div>
                </v-collapse-wrapper>
            </div>

            <!-- Vehicle Insurance -->
            <div class="card card-default">
                <v-collapse-wrapper>
                  <div class="card-header" v-collapse-toggle>
                    <h4 class="card-title m-0">
                          <a class="accordion-toggle">
                        <i class="fas fa-file-contract"></i>
                        {{ trans('Contracts & Other') }}
                      </a>
                    </h4>
                  </div>
                  <div id="collapseInsurance" v-collapse-content>
                    <vehicle-insurance
                      :leasing-company.sync="formData.leasing_company"
                      :insurance-company.sync="formData.insurance_company"
                      :tracker-id.sync="formData.tracker_id"
                      :microdots-pin.sync="formData.microdots_pin"
                      :nfc-id.sync="formData.nfc_id"
                      :nfc-buy.sync="formData.needs_nfc"
                      :hasAlarm.sync="formData.has_alarm"
                      :hasImmobilizer.sync="formData.has_immobilizer"
                      :errors="errors"
                    />
                  </div>
                </v-collapse-wrapper>
            </div>

            <!-- Vehicle Theft -->
            <div class="card card-default">
              <v-collapse-wrapper>
                <div class="card-header" v-collapse-toggle>
                  <h4 class="card-title m-0">
                          <a class="accordion-toggle">
                      <i class="fas fa-car-crash"></i>
                      {{ trans('Theft') }}
                    </a>
                  </h4>
                </div>
                <div id="collapseTheft" v-collapse-content>
                  <vehicle-theft
                    :is-stolen.sync="formData.is_stolen"
                    :street.sync="formData.street"
                    :place.sync="formData.postal_code"
                    :time-from.sync="formData.time_from"
                    :time-to.sync="formData.time_to"
                    :description.sync="formData.description"
                    :reward.sync="formData.reward"
                    :police-document.sync="formData.police_document"
                    :police-department.sync="formData.police_department"
                    :police-contact.sync="formData.police_contact"
                    :police-phone.sync="formData.police_phone"
                    :leasing-company.sync="formData.leasing_company"
                    :insurance-company.sync="formData.insurance_company"
                    :errors="errors"
                  />
                </div>
              </v-collapse-wrapper>
            </div>
          </v-collapse-group>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col text-center text-md-left">
        <div class="actions-continue">
          <input type="button"
                 :value="trans('Save')"
                 @click.prevent="sendData"
                 class="btn btn-primary btn-modern text-uppercase mt-5 mb-5 mb-lg-0">
        </div>
      </div>
    </div>

    <div v-show="loading" class="modal-backdrop fade show">
      <div style="margin-top: calc(50vh - 12px);">
        <preloader :loading="true" color="#fff" />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Toasted from 'vue-toasted';
import VueCollapse from 'vue2-collapse';

import { apiClient } from '../api';
import { getOffsetTop } from "../modules/get-offset-top";

import VehicleFilter from './Edit/VehicleFilter';
import VehicleInsurance from './Edit/VehicleInsurance';
import VehiclePhotos from './Edit/VehiclePhotos';
import VehicleTechs from './Register/VehicleTechs';
import VehicleTheft from './Register/VehicleTheft';
import CustomTextarea from './Register/VehicleTheft/CustomTextarea';

Vue.use(VueCollapse);
  Vue.use(Toasted, {
    position: 'bottom-right',
    duration: 5000, // ms
    keepOnHover: true,
  });

  export default {
    name: "VehicleEdit",

    components: {
      VehicleFilter,
      VehiclePhotos,
      VehicleTechs,
      VehicleInsurance,
      VehicleTheft,
      CustomTextarea,
    },

    props: {
      fields: {
        type: Object,
        required: true,
      },
      photoUploadRoute: {
        type: String,
        required: true,
      },
      vehicleRegisterRoute: {
        type: String,
        required: true,
      },
      preselectedPlan: {
        type: String,
        default: 'classic',
      }
    },

    data() {
      return {
        loading: false,
        formData: {
          '_method': 'PATCH',
          production_year: this.fields.production_year,
          color: {
            color: this.fields.color_id,
            is_metallic: this.fields.is_metallic,
          },
          vin: this.fields.vin,
          reg_date: this.fields.reg_date || {
            month: null,
            year: null,
          },
          reg_plate: this.fields.reg_plate,
          fuel: this.fields.fuel_type_id,
          power: this.fields.power,
          capacity: this.fields.engine_capacity,
          transmission: this.fields.transmission_id,
          speedometer_mph: Boolean(this.fields.speedometer_mph),
          odometer: this.fields.odometer,

          engine_number: this.fields.engine_number,
          gearbox_number: this.fields.gearbox_number,
          engine: {
            arrangement: this.fields.engine_configuration_id,
            cylinder_count: this.fields.cylinder_count,
          },
          extras: this.fields.extras || [],
          seat_material: this.fields.interior_material_id,
          interior_color: this.fields.interior_color_id,
          rims: this.fields.rims,
          rims_manufacturer: this.fields.rims_manufacturer,
          tyres: this.fields.tyres,
          special_signs: this.fields.special_signs,

          leasing_company: this.fields.leasing_company,
          insurance_company: this.fields.insurance_company,
          tracker_id: this.fields.tracker_id,
          microdots_pin: null,
          nfc_id: this.fields.nfc_id,
          has_alarm: this.fields.has_alarm,
          has_immobilizer: this.fields.has_immobilizer,

          is_stolen: Boolean(this.fields.is_stolen),
          street: this.fields.street,
          postal_code: this.fields.postal_code,
          time_from: this.fields.time_from,
          time_to: this.fields.time_to,
          reward: this.fields.reward,
          description: this.fields.description,
          police_document: this.fields.police_document,
          police_department: this.fields.police_document,
          police_contact: this.fields.police_document,
          police_phone: this.fields.police_document,
          ad_confirmation: this.fields.police_document,

          photos: this.fields.photos,
        },
        errors: {},
      }
    },

    computed: {
      filteredFormData() {
        return this.filterObject(this.formData);
      },
    },

    filters: {
      currency(val) {
        return val.toFixed(2) + ' €';
      }
    },

    methods: {
      filterObject(obj) {
        return Object.fromEntries(Object.entries(obj).filter(([key, val]) => {
          if (typeof (val) === 'boolean') {
            return true;
          }

          if (val === null) {
            return false;
          }

          if (typeof (val) === 'string') {
            return val.trim();
          }

          if (typeof (val) === 'object') {
            const result = this.filterObject(val);
            return !!Object.keys(result).length;
          }

          if (key === 'is_stolen') {
            return true;
          }

          return val;
        }));
      },

      sendData() {
        this.loading = true;
        this.errors = {};

        apiClient
          .post(this.vehicleRegisterRoute, this.filteredFormData)
          .then(response => {
            sessionStorage.removeItem('vehicleReportFormData');

            this.$nextTick(() => {
              if (response.data.result) {
                document.location.href = response.data.result;
              } else {
                document.location.reload();
              }
            });
          })
          .catch(error => {
            if (error.response.status === 422) {
              const data = error.response.data;
              this.errors = data.errors;

              this.$nextTick(() => {
                const errorLabel = document.querySelector('label.error');
                if (errorLabel) {
                  /* Scroll to first error if any */
                  window.scrollTo({
                    behavior: 'smooth',
                    top: getOffsetTop(errorLabel.parentNode) - (parseFloat(
                      document.defaultView.getComputedStyle(
                        document.querySelector('#header')
                      ).height) || 0)
                  });

                  /* Show toast */
                  this.$toasted.show(errorLabel.innerText, { type: 'error' });

                  /* Open collapsed sections with errors */
                  document.querySelectorAll('.collapse').forEach(section => {
                    const errorLabels = section.querySelectorAll('label.error');
                    if (errorLabels && errorLabels.length) {
                      section.classList.add('show');
                    }
                  });
                }

                this.loading = false;
              });
            }
          });
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "./resources/sass/variables";
  @import "./resources/sass/colors";

  .card-title i {
    min-width: 20px;
  }

  .sticky-top-plan {
    position: sticky !important;
    top: calc(#{$headerHeight} + 0.5rem);
  }

  .card-plan {
    border: 4px solid #F7F7F7;

    .card-header {
      padding: 10px 20px;
      border: none;

      .card-title {
        color: $primary;
      }
    }

    .plan-price {
      font-size: 2rem;
      font-weight: bold;
      white-space: nowrap;
    }
  }
</style>
